import { datadogLogs } from '@datadog/browser-logs';

/**
 * The Datadog browser session id for this tab's SDK instance, when the SDK has
 * been initialized and a session is active. Used to correlate main-thread and
 * shared-worker telemetry; returns undefined outside an initialized browser
 * context (tests, workers before init, SDK disabled).
 */
export function getDatadogSessionId(): string | undefined {
    return datadogLogs.getInternalContext()?.session_id;
}
